import FormJaivana from 'dashboard_jaivana_v1';
/**
 *
 * @author Juan David Nieto
 * @updateBy Sebastian Rios Echverri
 * Versiones corregidas: 1.01.0054
 */
/**
 * Custom con funciones adicionales al formulario de produccion - ajuste_agregacion
 **/
class CustomAgregarPuntos extends FormJaivana.form {

    constructor(props) {
        super(props);
        this.initForm                           = this.initForm.bind(this);
        this.retornaDatosFicha                  = this.retornaDatosFicha.bind(this);
        this.successRetornaDatosFicha           = this.successRetornaDatosFicha.bind(this);
        this.habilitarBtnAgregar                = this.habilitarBtnAgregar.bind(this);
        this.seguirFichaCalidad                 = this.seguirFichaCalidad.bind(this);
        this.closeFormulario                    = this.closeFormulario.bind(this);
        this.verFormula                         = this.verFormula.bind(this);
        this.successVerFormula                  = this.successVerFormula.bind(this);
        this.gridOptionsVerFormula              = Object.assign({}, this.gridOptions);
    }

    initForm() {
        console.log('Agregar Puntos, @Version: 1.01.0054, @Author: Juan David Nieto; @updateBy Sebastian Rios Echverri');
        this.retornaDatosFicha();
        this.getField('btn_agregar').setClick(this.seguirFichaCalidad);
        this.getField('btn_cancelar').setClick(this.closeFormulario);
        this.getField('btn_verformula').setClick(this.verFormula);
    }

    verFormula(){
        let datos = {
            datos:{
                value: this.props.data.id_ficha,
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'verformula', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successVerFormula,
            error: this.error_,
            showMessage: false,
            general: this.generalFormatPmv
        });
    }

    successVerFormula(data){
        if (data.estado_p === 200 && data.data.length >= 1) {
            this.getField('modal_verformula').handleClickOpen();
            this.getField('tb_verformula').toggle(true);
            this.gridOptionsVerFormula['rowData'] = data.model;
            let configCell = new Map();
            configCell.set('nombre_articulo',{headerName: 'Nombre Artículo'});
            configCell.set('version',{headerName: 'Versión'});
            configCell.set('produccion_formulas_versiones',{headerName: 'Producción Fórmulas Versiones'});
            configCell.set('estado_descripcion',{headerName: 'Estado Descripción'});
            this.getField('tb_verformula').initData(this.gridOptionsVerFormula, configCell);
        }else if (data.estado_p === 404){
            this.alertGeneral.toggle(true,'No hay datos',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }else{
            this.alertGeneral.toggle(true,'Error al consumir el servicio.',"error");
            this.getField('tb_verformula').toggle(true);
            this.getField('modal_verformula').handleClose();
        }
    }
    
    closeFormulario(){
        let dataEstado_p = {};
        dataEstado_p["estado_p"] = 200;
        this.successCloseEstage(dataEstado_p);
    }
    seguirFichaCalidad(){
        let datos = {
            datos:{
                id_formulario: this.formId,
                produccion_fichas_id:this.getField('produccion_fichas_id').getValue(),
                proceso_id:this.getField('proceso_id').getValue(),
                actividad_id:this.getField('actividad_id').getValue(),
                actividad_configuracion_id:this.getField('actividad_configuracion_id').getValue(),
                puntos: this.props.data.puntos
            }
        }

        this.generalFormatPmv = { tipo_servicio: 'prod-fichasetapas', operacion: 'continuar', operacion_tipo: 'crear' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'POST',
            body: datos,
            success: this.successCloseEstage,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '1216-continuar_siguiente_etapa'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'POST',
                body:body,
                success:this.successCloseEstage,
                error:this.error_,
                general: this.generalFormat
            });*/
    }
    retornaDatosFicha(){
        //console.log('data servicio');
        let datos = {
            datos:{
                value: this.props.data.id_ficha, 
            }
        }
        
        this.generalFormatPmv = { tipo_servicio: 'prod-fichas', operacion: 'iddatos', operacion_tipo: 'consulta' };
        this.service.send(
        {
            endpoint: this.constant.formConfiguration(),
            method:'GET',
            body: datos,
            success: this.successRetornaDatosFicha,
            error: this.error_,
            general: this.generalFormatPmv
        });
        /*this.generalFormat.nombre_accion = '1216-datos_ficha'; 
        this.service.send(
            {
                endpoint:this.constant.formConfiguration(),
                method:'GET',
                body:body,
                success:this.successRetornaDatosFicha,
                error:this.error_,
                general: this.generalFormat
            });*/
            //console.log('data servicio',body);

    }
    successRetornaDatosFicha(data){        
        this.getField('produccion_fichas_id').setValue(this.props.data.id_ficha);
        this.getField('proceso_id').setValue(this.props.data.proceso_id);
        this.getField('actividad_id').setValue(this.props.data.actividad_id);
        this.getField('actividad_configuracion_id').setValue(this.props.data.actividad_configuracion_id);
        if (data.estado_p === 200 && data.model !== undefined && data.model.length > 0){
            this.getField('info_ficha').setVisible(true);
            this.getField('info_ficha').setItemsFichas(data.model);
            this.getField('puntos_agregar').setValue(data.model[0].puntos);            
            this.habilitarBtnAgregar();
        }else{
            this.getField('info_ficha').setVisible(false);
        }
    }

    habilitarBtnAgregar(){
        if(this.getField('produccion_fichas_id').getValue()  !== '' &&
        this.getField('proceso_id').getValue() !== '' &&
        this.getField('actividad_id').getValue() !== '' &&
        this.getField('actividad_configuracion_id').getValue() !== '' &&
        this.getField('puntos_agregar') !== ''){
            this.getField('btn_agregar').setDisabled(false);
        }else{
            this.getField('btn_agregar').setDisabled(true);
        }
    }

}

FormJaivana.addController("prod-agregarpuntos",CustomAgregarPuntos);
export default CustomAgregarPuntos;

